interface AdherenceBarProps {
  memberName: string;
  percentage: number;
  taken: number;
  total: number;
  status: 'excellent' | 'good' | 'warning' | 'none';
}

export default function AdherenceBar({ memberName, percentage, taken, total, status }: AdherenceBarProps) {
  const statusConfig = {
    excellent: { icon: '✅', color: 'bg-emerald-500', textColor: 'text-emerald-600' },
    good: { icon: '✅', color: 'bg-blue-500', textColor: 'text-blue-600' },
    warning: { icon: '⚠️', color: 'bg-orange-500', textColor: 'text-orange-500' },
    none: { icon: '❌', color: 'bg-gray-300', textColor: 'text-gray-500' }
  };
  
  const config = statusConfig[status];
  
  // Limitar porcentagem a 100% máximo para evitar overflow visual
  const displayPercentage = Math.min(percentage, 100);
  
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <span className="flex items-center gap-2 text-base font-semibold text-slate-700 font-sans">
          <span className="text-lg leading-none">{config.icon}</span>
          {memberName}
        </span>
        <span className={`text-base font-bold ${config.textColor} font-sans`}>
          {percentage}%
        </span>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-3.5 overflow-hidden">
        <div
          className={`${config.color} h-full rounded-full transition-all duration-500`}
          style={{ width: `${displayPercentage}%`, maxWidth: '100%' }}
        />
      </div>
      <p className="text-sm text-slate-500 mt-2 font-sans font-medium">
        {`${taken}/${total} doses`}
      </p>
    </div>
  );
}
